import { SearchTerm } from './SearchTerm';

const UserLoginSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "ulUsername",
        translationKey: "name"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "master.mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        searchOnName: "master.mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default UserLoginSearch;
